(() => {
  'use strict';
  document.addEventListener('click', (event) => {
    const categoryArrow = event.target.closest('[data-category-scroll]');
    if (categoryArrow) { const row = categoryArrow.closest('[data-category-section]').querySelector('.category-grid'); row.scrollBy({left: row.clientWidth * Number(categoryArrow.dataset.categoryScroll), behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'}); }
    const thumbnail = event.target.closest('[data-gallery-image]');
    if (thumbnail) {
      const image = thumbnail.closest('[data-product-section]').querySelector('[data-gallery] img');
      if (image) { image.src = thumbnail.dataset.galleryImage; image.removeAttribute('srcset'); image.alt = thumbnail.dataset.galleryAlt || ''; }
    }
    document.querySelectorAll('.site-header details[open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') document.querySelectorAll('.site-header details[open]').forEach((details) => { details.open = false; details.querySelector('summary').focus(); });
  });
  function updateSellingPlan(section) {
    const select = section.querySelector('[name="selling_plan"]');
    if (!select) return;
    const variant = section.querySelector('[data-variant-select]').selectedOptions[0];
    let allocations = [];
    try { const parsed = JSON.parse(variant.dataset.plans || '[]'); if (Array.isArray(parsed)) allocations = parsed.filter(plan => plan && plan.id != null && typeof plan.price === 'string'); } catch (_) { /* Invalid optional app data must not break product selection. */ }
    Array.from(select.options).forEach(option => { option.disabled = option.value !== '' && !allocations.some(plan => String(plan.id) === option.value); });
    if (!select.selectedOptions.length || select.selectedOptions[0].disabled) {
      const first = Array.from(select.options).find(option => !option.disabled);
      select.value = first ? first.value : '';
    }
    const allocation = allocations.find(plan => String(plan.id) === select.value);
    section.querySelector('[data-product-price]').textContent = allocation ? allocation.price : variant.dataset.price;
    const button = section.querySelector('[data-add-button]');
    button.disabled = variant.dataset.available !== 'true' || !select.selectedOptions.length;
    button.textContent = button.disabled ? 'Unavailable' : 'Add to cart';
  }
  function initProductForms(root = document) {
    if (root.matches?.('[data-product-section]')) updateSellingPlan(root);
    root.querySelectorAll('[data-product-section]').forEach(updateSellingPlan);
  }
  initProductForms();
  document.addEventListener('shopify:section:load', event => initProductForms(event.target));
  document.addEventListener('change', (event) => {
    if (event.target.matches('[name="selling_plan"]')) { updateSellingPlan(event.target.closest('[data-product-section]')); return; }

    if (!event.target.matches('[data-variant-select]')) return;
    const option = event.target.selectedOptions[0];
    const section = event.target.closest('[data-product-section]');
    section.querySelector('[data-product-price]').textContent = option.dataset.price;
    const compare = section.querySelector('[data-product-compare]');
    compare.textContent = option.dataset.compare; compare.hidden = !option.dataset.compare;
    const available = option.dataset.available === 'true';
    const button = section.querySelector('[data-add-button]');
    button.disabled = !available; button.textContent = available ? 'Add to cart' : 'Sold out';
    section.querySelector('[data-product-stock]').textContent = available ? 'In stock' : 'Sold out';
    section.querySelector('[data-product-sku]').textContent = option.dataset.sku;
    const quantity = section.querySelector('[name="quantity"]');
    quantity.min = option.dataset.min; quantity.step = option.dataset.increment;
    if (option.dataset.max) quantity.max = option.dataset.max; else quantity.removeAttribute('max');
    quantity.value = option.dataset.min;
    const image = section.querySelector('[data-gallery] img');
    if (image && option.dataset.image) { image.src = option.dataset.image; image.removeAttribute('srcset'); }
    updateSellingPlan(section);
    const url = new URL(location.href); url.searchParams.set('variant', option.value); history.replaceState({}, '', url);
  });
  function initRecommendations(root = document) {
    root.querySelectorAll('[data-recommendations-url]:not([data-loaded])').forEach(async (element) => {
      element.dataset.loaded = 'true';
      try {
        const response = await fetch(element.dataset.recommendationsUrl);
        if (!response.ok) return;
        const html = new DOMParser().parseFromString(await response.text(), 'text/html');
        const content = html.querySelector('[data-recommendations-content]');
        if (content) element.querySelector('[data-recommendations-content]').replaceChildren(...content.childNodes);
      } catch (_) { /* Optional recommendations do not block shopping. */ }
    });
  }
  initRecommendations();
  document.addEventListener('shopify:section:load', (event) => initRecommendations(event.target));
})();
